import API from "../constants/api.constant";
import { responseErrorHandling } from "../helper/common.helper";
import axiosInstance from "./axiosInstance";

export const createCustomer = async (payload: Object) => {
  try {
    const response = await axiosInstance.post(
      API.CREATE_CUSTOMER_PROFILE,
      payload,
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const getCustomers = async (payload: Object) => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_CUSTOMER, {
      params: payload,
    });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const deleteCustomerById = async (id: string) => {
  try {
    const response = await axiosInstance.delete(API.DELETE_CUSTOMER + id);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const updateCustomer = async (id: string, payload: object) => {
  try {
    const response = await axiosInstance.patch(
      API.UPDATE_CUSTOMER + id,
      payload,
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

export const blockCustomer = async (id: string, payload: object) => {
  try {
    const response = await axiosInstance.patch(
      API.BLOCK_CUSTOMER + id,
      payload,
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// change Customer password
export const changeCustomerPassword = async (id: string, data: object) => {
  try {
    const response = await axiosInstance.put(
      API.CUSTOMER_PASSWORD_CHANGE + id,
      data,
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// get Customer profile
export const getCustomerProfile = async (id: string) => {
  try {
    const response = await axiosInstance.get(API.GET_CUSTOMER_PROFILE + id);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// update Customer profile
export const updateCustomerProfile = async (id: string, data: object) => {
  try {
    const response = await axiosInstance.patch(API.UPDATE_CUSTOMER + id, data);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// customer invitations link
export const customerInvitationLink = async (businessId: string) => {
  try {
    const response = await axiosInstance.get(
      API.CUSTOMER_INVITATION_LINK + businessId,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

// send customer registration invite
export const sendRegisterInvitationCustomer = async (data: object) => {
  try {
    const response = await axiosInstance.post(
      API.SEND_REGISTER_INVITE_CUSTOMER,
      data,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const uploadBusinessDocument = async (
  customerId: string,
  customerBusinessId: string,
  docName: string,
  file: File,
) => {
  try {
    const formData = new FormData();
    formData.append("customerId", customerId);
    formData.append("customerBusinessId", customerBusinessId);
    formData.append("docName", docName);
    formData.append("file", file);

    const response = await axiosInstance.post(
      API.UPLOAD_CUSTOMER_BUSINESS_DOC,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const createBusinessDocument = async (
  customerId: string,
  customerBusinessId: string,
  docName: string,
  originalName: string,
  filePath: string,
  mimeType?: string,
) => {
  try {
    const response = await axiosInstance.post(API.CREATE_CUSTOMER_BUSINESS_DOC, {
      customerId,
      customerBusinessId,
      docName,
      originalName,
      filePath,
      mimeType,
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getBusinessDocumentUploadSignature = async (
  folder = "businessDocuments",
  uploadName?: string,
) => {
  try {
    const publicId = uploadName;
    const response = await axiosInstance.post(
      API.CUSTOMER_BUSINESS_DOC_UPLOAD_SIGNATURE,
      {
        folder,
        ...(publicId ? { publicId, filenameOverride: uploadName } : {}),
      },
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getBusinessDocuments = async (
  customerId: string,
  customerBusinessId: string,
) => {
  try {
    const response = await axiosInstance.get(
      `${API.GET_CUSTOMER_BUSINESS_DOC}${customerId}/${customerBusinessId}`,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const deleteBusinessDocument = async (docId: string) => {
  try {
    const response = await axiosInstance.delete(
      `${API.DELETE_BUSINESS_DOC}${docId}`,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const openBusinessDocumentFile = async (docId: string) => {
  try {
    const response = await axiosInstance.get(
      `${API.GET_CUSTOMER_BUSINESS_DOC_FILE}${docId}`,
      { responseType: "blob" },
    );
    const fileUrl = URL.createObjectURL(response.data);
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const createCustomerLoanRequest = async (
  customerId: string,
  data: Object,
) => {
  try {
    const response = await axiosInstance.post(
      `${API.CREATE_LOAN_REQUEST}${customerId}`,
      data,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const createBusinessLoanRequest = async (
  businessId: string,
  data: Object,
) => {
  try {
    const response = await axiosInstance.post(
      `${API.CREATE_BUSINESS_LOAN_REQUEST}${businessId}`,
      data,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getCustomerLoanRequest = async (dealId: string) => {
  try {
    const response = await axiosInstance.get(
      `${API.GET_LOAN_REQUEST}${dealId}`,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const updateCustomerLoanRequest = async (dealId: string, data: any) => {
  try {
    const response = await axiosInstance.patch(
      `${API.UPDATE_LOAN_REQUEST}${dealId}`,
      data,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const updateLoanProceeds = async (dealId: string, proceeds: { purpose: string; amount: number }[]) => {
  try {
    const response = await axiosInstance.patch(
      `${API.UPDATE_LOAN_PROCEEDS}${dealId}/proceeds`,
      { proceeds },
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const updateLoanClosing = async (
  dealId: string,
  data: { status?: string; closingDate?: string | null },
) => {
  try {
    const response = await axiosInstance.patch(
      `${API.UPDATE_LOAN_CLOSING}${dealId}/closing`,
      data,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const generateTransactionSummary = async (
  dealId: string,
  data: { prompt: string; dealData: Record<string, any> },
) => {
  try {
    const response = await axiosInstance.post(
      `${API.GENERATE_TRANSACTION_SUMMARY}${dealId}/generate-transaction-summary`,
      data,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getClosingAlerts = async () => {
  try {
    const response = await axiosInstance.get(API.GET_CLOSING_ALERTS);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getAllBusinessCustomerLoan = async (businessId: string) => {
  try {
    const response = await axiosInstance.get(
      API.GET_ALL_LOAN_REQUEST + "/" + businessId,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getAllCustomerLoanRequest = async (search?: string) => {
  try {
    const response = await axiosInstance.get(API.GET_CUSTOMER_LOAN_REQUEST, {
      params: search ? { search } : {},
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getInactiveDeals = async (
  search: string = "",
  page: number = 1,
  limit: number = 25,
) => {
  try {
    const response = await axiosInstance.get(API.GET_INACTIVE_DEALS, {
      params: { page, limit, search },
    });
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getAllBankerRegistration = async () => {
  try {
    const response = await axiosInstance.get(API.GET_ALL_BANKER_REGISTER);
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const assignDealBankers = async (
  dealId: string,
  bankerIds: string[],
  isShareCustomerDetails: boolean,
) => {
  try {
    const response = await axiosInstance.post(
      API.ASSIGN_DEAL_BANKERS + dealId,
      { bankerIds, isShareCustomerDetails },
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const assignDealBankersWithInvites = async (
  dealId: string,
  bankerIds: string[],
  importedBankerIds: string[],
  isShareCustomerDetails: boolean,
) => {
  try {
    const response = await axiosInstance.post(
      API.ASSIGN_DEAL_BANKERS_WITH_INVITES + dealId,
      { bankerIds, importedBankerIds, isShareCustomerDetails },
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const deleteCustomerLoanRequest = async (dealId: string) => {
  try {
    const response = await axiosInstance.delete(
      `${API.DELETE_LOAN_REQUEST}${dealId}`,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const getTermSheetForDeal = async (dealId: string, bankerId: string) => {
  try {
    const response = await axiosInstance.get(
      `${API.GET_TERM_SHEET_FOR_DEAL}${dealId}/${bankerId}`,
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

export const uploadCustomerDocument = async (
  documentId: string,
  file: File,
) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axiosInstance.post(
      `${API.UPLOAD_CUSTOMER_DOCUMENT}${documentId}`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      },
    );
    return response.data;
  } catch (error) {
    responseErrorHandling(error);
  }
};

// Get customer businesses
export const getCustomerBusinesses = async (
  search?: string,
  page: number = 1,
  limit: number = 10,
) => {
  try {
    const params: any = { page, limit };
    if (search) {
      params.search = search;
    }
    const response = await axiosInstance.get(API.CUSTOMER_GET_BUSINESSES, {
      params,
    });
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// create customer business
export const createCustomerBusiness = async (data: object) => {
  try {
    const response = await axiosInstance.post(
      API.CUSTOMER_CREATE_BUSINESS,
      data,
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// Update customer business
export const updateCustomerBusiness = async (id: string, data: object) => {
  try {
    const response = await axiosInstance.patch(
      API.CUSTOMER_UPDATE_BUSINESS + id,
      data,
    );
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};

// Get customer tax data by docId
export const getCustomerTaxData = async (businessId: string) => {
  try {
    const response = await axiosInstance.get(API.CUSTOMER_TAX_DATA + businessId);
    return response.data;
  } catch (error: any) {
    responseErrorHandling(error);
  }
};
